import GUI from 'lil-gui';
import VConsole from 'vconsole';
import * as THREE from 'three';
import { StatsModule } from '../../../compontent/stats.ts';
import { EngineConfig } from '../config/index.ts';
import { checkIsSafari } from '../../../../utils/index.ts';
let gridSize = 1;
let spaceSize = 50;
interface DebugPanelConf {
  showGSInfo: boolean;
  gridSize: number;
  spaceSize: number;
  onSaveLocation: () => void;
  onRestoreLocation: () => void;
  onResetLocation: () => void;
  onTestLowFrame: () => void;
}
export default class DebugPanel {
  private metaView: any;
  private state: StatsModule | null;
  private gui: GUI = null as unknown as GUI;
  private vConsole: VConsole | null = null as unknown as VConsole;
  private isHidden?: boolean;
  private debugPanelConf: DebugPanelConf = null as unknown as DebugPanelConf;
  constructor(metaView: any) {
    this.metaView = metaView;
    this.state = new StatsModule({
      containerId: 'app',
      type: 0,
      style: {
        position: 'absolute',
        top: checkIsSafari() && window.innerWidth < window.innerHeight ? '50px' : '0',
      },
    });
    this.state?.show();
  }

  createGui() {
    this.gui = new GUI({ container: document.getElementById('metaverse')! });
    this.gui.domElement.style.position = 'absolute';
    this.gui.domElement.style.top = '10%';
    this.gui.domElement.style.right = '0';
    this.debugPanelConf = {
      // firstView: false,
      // cameraSpeed: 0.3,
      // collisionTest: false,
      showGSInfo: false,
      gridSize: 1,
      spaceSize: 30,
      // engine: this.getEngine(),
      onSaveLocation: this.onSaveLocation.bind(this),
      onRestoreLocation: this.onRestoreLocation.bind(this),
      onResetLocation: this.onResetLocation.bind(this),
      onTestLowFrame: this.onTestLowFrame.bind(this),
    };
    // 使用全局的 VConsole 实例而不是创建新的
    this.vConsole = new VConsole();
    this.init();
  }

  show(): void {
    if (!this.gui) {
      this.createGui();
    }
    console.log('show panel');
    this.isHidden = false;
    this.gui?.show();
    // this.state?.show();
    // 使用全局 VConsole 实例的方法
    if (this.vConsole && typeof this.vConsole.showSwitch === 'function') {
      this.vConsole.showSwitch();
    }
  }

  hide(): void {
    if (this.gui) {
      console.log('hide panel');
      this.gui.hide();
    }
    this.isHidden = true;
    // 使用全局 VConsole 实例的方法
    if (this.vConsole && typeof this.vConsole.hideSwitch === 'function') {
      this.vConsole.hideSwitch();
    }
  }

  animate(): void {
    this.state!.stats!.update();
  }

  onSaveLocation(): void {
    this.metaView.playerController.saveCurrentPosition(this.metaView.sceneController, 'default');
  }

  onRestoreLocation(): void {
    this.metaView.playerController.restoreSavedPosition(this.metaView.sceneController, 'default');
  }

  onResetLocation(): void {
    this.metaView.playerController.setPosition(0, 0, 0);
  }

  onTestLowFrame(): void {
    this.metaView.enterLowFrameRateMode();
  }

  init(): void {
    this.gui.add(this.debugPanelConf, 'showGSInfo').onChange(() => {
      if (this.debugPanelConf.showGSInfo) {
        console.log('showGSInfo');
        this.metaView.sceneController.showInfoPanel(true);
      } else {
        this.metaView.sceneController.showInfoPanel(false);
      }
    });
    this.gui.add(this.debugPanelConf, 'gridSize', 1, 30, 1).onChange(() => {
      gridSize = this.debugPanelConf.gridSize;
      createWalls(this.metaView.sceneController.getScene());
    });
    this.gui.add(this.debugPanelConf, 'spaceSize', 30, 150, 10).onChange(() => {
      spaceSize = this.debugPanelConf['空间大小'];
      createWalls(this.metaView.sceneController.getScene());
    });
    this.gui.add(this.debugPanelConf, 'onSaveLocation').name('保存位置');
    this.gui.add(this.debugPanelConf, 'onRestoreLocation').name('恢复位置');
    this.gui.add(this.debugPanelConf, 'onTestLowFrame').name('测试低帧率模式');
    this.gui.add(this.debugPanelConf, 'onResetLocation').name('重置位置');
    this.gui.hide();
    this.vConsole?.hideSwitch();
  }

  getEngine(): string {
    if (localStorage.getItem('engine') === null) {
      return EngineConfig.GaussianSplats3D;
    }
    return localStorage.getItem('engine') || '';
  }
}

let walls: THREE.Mesh[] = [];

function createWalls(scene: THREE.Scene): void {
  // 清除旧墙面
  walls.forEach((wall) => scene.remove(wall));
  walls = [];

  const wallHeight = 20;
  const wallThickness = 0.2;
  const spacing = spaceSize / gridSize;
  const offset = spaceSize / 2 - spacing / 2;

  // X轴方向墙材质 (红色)
  const xWallMaterial = new THREE.MeshStandardMaterial({
    color: 0xff0000,
    transparent: true,
    side: THREE.DoubleSide,
  });

  // Z轴方向墙材质 (蓝色)
  const zWallMaterial = new THREE.MeshStandardMaterial({
    color: 0x0000ff,
    transparent: true,
    side: THREE.DoubleSide,
  });

  // 生成X轴方向的墙 (垂直于Z轴)
  for (let i = 0; i < gridSize - 1; i++) {
    for (let j = 0; j < gridSize; j++) {
      const wall = new THREE.Mesh(new THREE.BoxGeometry(spaceSize, wallHeight, wallThickness), xWallMaterial);
      wall.position.set(-offset + i * spacing, wallHeight / 2, -offset + j * spacing);
      walls.push(wall);
      scene.add(wall);
    }
  }

  // 生成Z轴方向的墙 (垂直于X轴)
  for (let i = 0; i < gridSize; i++) {
    for (let j = 0; j < gridSize - 1; j++) {
      const wall = new THREE.Mesh(new THREE.BoxGeometry(wallThickness, wallHeight, spaceSize), zWallMaterial);
      wall.position.set(-offset + i * spacing, wallHeight / 2, -offset + j * spacing);
      walls.push(wall);
      scene.add(wall);
    }
  }

  console.log(`创建 ${gridSize}x${gridSize} 网格，共 ${walls.length} 堵墙`);
}
